import { render, staticRenderFns } from "./CategorySelectModal.vue?vue&type=template&id=407ab449&scoped=true"
import script from "./CategorySelectModal.vue?vue&type=script&lang=js"
export * from "./CategorySelectModal.vue?vue&type=script&lang=js"
import style0 from "./CategorySelectModal.vue?vue&type=style&index=0&id=407ab449&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ab449",
  null
  
)

export default component.exports